/**
 * The one place a context role is put into words. The business dashboard and
 * the context chooser both show a person which hat they wear on a business;
 * before this file each carried its own copy of the map.
 */
export const ROLE_LABELS: Readonly<Record<string, string>> = {
  'entity-admin': 'Entity Admin',
  'entity-member': 'Entity Member',
  agent: 'Agent',
  'capx-admin': 'Platform Admin',
};

export const ROLE_TOOLTIPS: Readonly<Record<string, string>> = {
  'entity-admin': 'Can manage business settings, members, and applications',
  'entity-member': 'Can view and submit applications on behalf of this business',
  agent: 'Can view and act on applications for linked businesses',
  'capx-admin': 'Internal platform administrator',
};

/** Label for a role code; an unmapped code renders as itself, never blank. */
export function roleLabel(role: string): string {
  return ROLE_LABELS[role] ?? role;
}

export function roleTooltip(role: string): string {
  return ROLE_TOOLTIPS[role] ?? '';
}
